<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      {{titolo}}
    </div>
  </mat-card-title>
  <mat-card-content>
    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div class="container">

        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Cognome" id="Cognome" matInput type="text"
                     placeholder="Cognome">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Nome" id="Nome" matInput type="text"
                     placeholder="Nome">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Email" id="Email" matInput type="email"
                     placeholder="Email">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Password" id="Password" matInput type="password"
                     placeholder="Password">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <mat-select placeholder="Ateneo" formControlName="idAteneo"                         
                          id="idAteneo"
                           (selectionChange)="getListaDipartimenti($event.value)">
                <mat-option *ngFor="let obj of lstAtenei" [value]="obj.idAteneo">
                  {{obj.Ateneo}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <mat-select formControlName="idDipartimento" placeholder="Dipartimento" 
                          id="idDipartimento">
                <mat-option *ngFor="let obj of lstDipartimenti" [value]="obj.idAteneo">
                  {{obj.Dipartimento}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <section>
              <mat-checkbox type="checkbox" formControlName="NewsLetterStrutturato" id="NewsLetterStrutturato">Newsletter Strutturato</mat-checkbox>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <mat-checkbox type="checkbox" formControlName="NewsLetterNonStrutturato" id="NewsLetterNonStrutturato">Newsletter Non Strutturato</mat-checkbox>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <mat-checkbox type="checkbox" formControlName="NewsLetterGenerica" id="NewsLetterGenerica">Newsletter Generica</mat-checkbox>
            </section>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <mat-select placeholder="Ruolo" formControlName="idRuolo" required
                          id="idRuolo">
                <mat-option *ngFor="let obj of lstRuolo" [value]="obj.idRuolo">
                  {{obj.DescrizioneRuolo}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <section>
              <label>Referente</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <mat-radio-group formControlName="idReferenteTipologia">
                <mat-radio-button *ngFor="let obj of lstReferente" [value]="obj.idReferenteTipologia">
                  {{obj.ReferenteTipologia}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </mat-radio-button>
              </mat-radio-group>
            </section>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <mat-select placeholder="Settore scientifico disciplinare - S.S.D." formControlName="idSettoreScientifico"
                          id="idSettoreScientifico">
                <mat-option *ngFor="let obj of lstSettoreScientifico" [value]="obj.idSettoreScientifico">
                  {{obj.SettoreScientificoDescrizione}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input matInput type="text"
                     placeholder="Telefono" formControlName="Telefono"
                     id="Telefono" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <input matInput
                     placeholder="Codice Fiscale" formControlName="CodiceFiscale"
                     id="CodiceFiscale" />
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="isEdit">
          <div class="col-md-4">
            <div class="mat-form-field">
              <mat-checkbox id="isVerificato" formControlName="isVerificato">
                Verificato
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>


      <div mat-dialog-actions>
        <button mat-raised-button color="primary"
                (click)="btnAnnulla()">
          Annulla
        </button>
        <button mat-raised-button color="primary"
                [disabled]="!frmInserimento.valid"
                (click)="btnSalva()">
          Salva
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>
